module.exports = __webpack_public_path__ + "img/Proliferation-CRC_CRLM.6e569355.png";